/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 11:18:28
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-23, 14:45:21
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import AppVersion from '@/components/Common/AppVersion';
import LoginLogo from '@/components/Login/LoginLogo';
import LoginSubscriberNumberForm from '@/components/Login/LoginSubscriberNumberForm';
import LoginRpcErrorMessage from '@/components/Login/LoginRpcErrorMessage';
import LoginCopyright from '@/components/Login/LoginCopyright';
// dynamic import
const LoginSmsTokenForm = () => import('@/components/Login/LoginSmsTokenForm');
const LoginSubscriberPasswordForm = () => import('@/components/Login/LoginSubscriberPasswordForm');
const LoginCreatePasswordForm = () => import('@/components/Login/LoginCreatePasswordForm');

// CONTAINER ///////////////////////////////////////////////////////////////////
const Login = {
  components: {
    AppVersion,
    LoginLogo,
    LoginSubscriberNumberForm,
    LoginRpcErrorMessage,
    LoginCopyright,
    LoginSmsTokenForm,
    LoginSubscriberPasswordForm,
    LoginCreatePasswordForm,
  },
  store,
  computed: {
    ...mapGetters(['authType', 'subscriber', 'isAuthenticated', 'loginCredentialsIncorrect', 'loginLoadingActive', 'brandLogos', 'isError']),
    mapAuthTypeToComponent() {
      const componentsMap = {
        initial: 'LoginSubscriberNumberForm',
        login: 'LoginSubscriberPasswordForm',
        createNewPassword: 'LoginCreatePasswordForm',
        createNewPasswordForRegisteredUser: 'LoginCreatePasswordForm',
        registration: 'LoginSmsTokenForm',
        sendSmsAfterPasswordChangeRequest: 'LoginSmsTokenForm',
      };

      return componentsMap[this.authType];
    },
  },
  watch: {
    isAuthenticated(value) {
      if (value) {
        window.location.reload(true);
        // this.$router.push('my-account');
      } else {
        this.$router.push('/');
      }
    },
  },
  template: `
    <div class="my-container">
      <div class="login-container">
        <LoginLogo :brand-logos="brandLogos" />
        <LoginRpcErrorMessage v-if="isError" />
        <component v-if="!isError"
          :is="mapAuthTypeToComponent" 
          :login-credentials-incorrect="loginCredentialsIncorrect" 
          :subscriber="subscriber" 
          :login-loading-active="loginLoadingActive"     
        />
      </div>
      <LoginCopyright year="${new Date().getFullYear()}" />
      <AppVersion />
    </div>
  `,
};

export default Vue
  .component('Login', Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js